import React from 'react';
import { DownloadButton, SelectMenu } from '../../../ui-kit';
import type { TableSection } from '../useTableSection';

/**
 * A board table's header controls: its Cohort select and its Download. Every
 * table on the board labels its grouping "Cohort", whatever date it groups by,
 * so the control reads the same everywhere; Download is the same control a
 * Copilot result has.
 */
/** The table's Cohort picker, on the left of its panel's toolbar. Nothing when there is one choice. */
export function TableSectionTools({ section }: { section: TableSection }) {
  return section.options.length > 1 ? (
    <SelectMenu label="Cohort" value={section.grain} options={section.options} onChange={section.setGrain} />
  ) : null;
}

/** The table's Download, on the right of its panel's toolbar. */
export default function TableSectionActions({
  section,
  disabled,
}: {
  section: TableSection;
  disabled?: boolean;
}) {
  return (
    <DownloadButton
      formats={[{ key: 'xlsx', label: 'Excel (.xlsx)', onDownload: section.exportTable }]}
      tooltip="Download this table as Excel, as shown"
      loading={section.downloading}
      disabled={disabled}
    />
  );
}
